import React from 'react';

import BaseSvg, { BaseSvgProps } from '../../BaseSvg';

const ForceSvg: React.FunctionComponent<BaseSvgProps> = ({ className = '', fillColor, secondaryFillColor }) => {
    return (
        <BaseSvg className={className} viewBox="0 0 17.8 17.84">
            <line fill={fillColor} stroke={fillColor} strokeMiterlimit={10} x1="15.58" y1="5.38" x2="13.21" y2="8.54" />
            <line fill={fillColor} stroke={fillColor} strokeMiterlimit={10} x1="12.42" y1="2.22" x2="6.1" y2="6.96" />
            <path
                fill={fillColor}
                stroke={fillColor}
                strokeMiterlimit={10}
                d="M.7,14.06a2.46,2.46,0,0,0,.82,2.49,2.48,2.48,0,0,0,2.76.12l.24.55,4.74-.79s-2.11,0-2.37,0a39.42,39.42,0,0,1,3.16-2.37c-1,.25-2.76.57-3.54.72L15.58,2.22,3.73,10.77v-3l-1.33,4L2.06,12,1.37,8.54.58,14.06Zm2.24-1.58a9.06,9.06,0,0,0,4.49-2.11c.15-.16.25-.26.25-.26s-.16.17-.25.26A4.61,4.61,0,0,0,6.1,14.06c.39,2.14-2.73,1.38-3.95,2.37C2.58,15,1.37,12.81,2.94,12.48Z"
            />
            <path
                fill={fillColor}
                stroke={fillColor}
                strokeMiterlimit={10}
                d="M7.68,10.12c-.08.09-.16.17-.25.26C7.58,10.21,7.68,10.12,7.68,10.12Z"
            />
        </BaseSvg>
    );
};

export default ForceSvg;
